// import { getWatermark } from "@/utils/watermark";

import { getCoNameWatermark, getWatermark } from "@/utils/watermark";

const watermark = {
  inserted: (_el) => {
    const width =
      parseInt(_el.style.width) || parseInt(window.getComputedStyle(_el).width);
    const height =
      parseInt(_el.style.height) ||
      parseInt(window.getComputedStyle(_el).height);

    if (width && height) {
      _el.style.position = "relative";
      const watermarkDiv = document.createElement("div");
      watermarkDiv.style.backgroundImage = `url("${getWatermark(
        width,
        height
      )}")`;
      const coWaterMark = document.createElement("div");
      coWaterMark.style.backgroundImage = `url("${getCoNameWatermark(
        width,
        height
      )}")`;

      watermarkDiv.style.position = coWaterMark.style.position = "absolute";
      watermarkDiv.style.top = coWaterMark.style.top = "0";
      watermarkDiv.style.left = coWaterMark.style.left = "0";
      watermarkDiv.style.width = coWaterMark.style.width = "100%";
      watermarkDiv.style.height = coWaterMark.style.height = "100%";
      watermarkDiv.style.opacity = coWaterMark.style.opacity = "0.5";
      _el.appendChild(watermarkDiv);
      _el.appendChild(coWaterMark);
    }
  },
};

export default {
  install(Vue) {
    Vue.directive("watermark", watermark);
  },
};
